import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, lead, center = false, size = "lg" }) => (
  <div className={center ? "text-center flex flex-col items-center" : ""}>
    <Reveal>
      <div className={`eyebrow ${center ? "eyebrow-center" : ""}`}>{eyebrow}</div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`section-title ${
          size === "lg" ? "text-3xl sm:text-4xl lg:text-6xl" : "text-2xl sm:text-3xl lg:text-4xl"
        } ${center ? "max-w-4xl" : "max-w-3xl"} ${center ? "" : ""}`}
      >
        {title}
      </h2>
    </Reveal>
    {lead ? (
      <Reveal delay={0.16}>
        <p className={`lead mt-6 ${center ? "max-w-2xl mx-auto" : "max-w-2xl"}`}>{lead}</p>
      </Reveal>
    ) : null}
  </div>
);
